import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { SourceItem } from '../../constants/source-items';
import { renderIcon } from '../icon';

type Props = {
	onClick: (item: SourceItem) => void;
	item: SourceItem;
	loading?: boolean;
};

export const SourceCardItem = ({ onClick, item, loading }: Props) => (
	<ButtonWrapper
		onClick={() => onClick(item)}
		aria-label={item.name}
		loading={loading}
		disabled={loading}
	>
		{loading ? (
			<Spinner
				size="small"
				testId="project-create-importer-upload-flow.common.ui.source-card-item.spinner"
			/>
		) : (
			<>
				{renderIcon(item.icon, true)}
				<Box paddingInlineStart="space.100" as="span" xcss={serviceNameStyles}>
					{item.name}
				</Box>
			</>
		)}
	</ButtonWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.button<{ loading?: boolean }>({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	justifyContent: ({ loading }) => (loading ? 'center' : 'flex-start'),
	flexDirection: 'row',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.text.inverse', colors.N0),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `solid 1px ${token('color.border', colors.N30)}`,
	borderRadius: '4px',
	padding: token('space.200', '16px'),
	width: '200px',
	height: '56px',
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered', 'rgba(9, 30, 66, 0.06)'),
	},
	'&:active': {
		borderColor: token('color.border.selected', 'rgba(12, 102, 228, 1)'),
		backgroundColor: token('color.background.selected', 'rgba(233, 242, 255, 1)'),
		outline: 'none',
	},
});

const serviceNameStyles = xcss({
	font: token('font.heading.xxsmall'),
	fontWeight: token('font.weight.medium'),
	color: 'color.text.subtle',
});
